/*Helper function to simplify the work of getting data from the session storage*/

export const getSessionStorage = (key: string) => {
  const currentStorage = window.sessionStorage.getItem(key);
  
  if (!currentStorage || typeof currentStorage !== 'object') return false;

  const parsedStorage = JSON.parse(currentStorage);

  if (!parsedStorage) return false;

  return parsedStorage;
};

/*Helper function to simplify the work of setting data from the session storage*/

export const setSessionStorage = (key: string, data: {}) => {
  let existingData = getSessionStorage(key);

  const stringifiedDataFull = JSON.stringify({ ...existingData, ...data });
  window.sessionStorage.setItem(key, stringifiedDataFull);
};
